// extracted by mini-css-extract-plugin
export var sliderRange = "_o5-2";
export var sliderRoot = "_o5-0";
export var sliderThumb = "_o5-3";
export var sliderTrack = "_o5-1";